<template>
  <vx-card>
    <vs-alert class="mb-3">
      <p class="text-sm sm:text-base">Este modulo es para ver los tareas y archivos asociados a un periodo específico.</p>
    </vs-alert>
    <div class="mt-2">
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 mb-4 md:mb-0">
          <span class="font-semibold">Seleccione la región</span>
          <ul class="flex mt-2" style="flex-wrap: wrap;">
            <li class="mr-3">
              <vs-radio v-model="region" @input="limpiarDatosYCambiarRegion();" vs-name="radios1tipoFiltro" vs-value="1">Sierra</vs-radio>
            </li>
            <li class="mr-3">
              <vs-radio v-model="region" @input="limpiarDatosYCambiarRegion();" vs-name="radios1tipoFiltro" vs-value="2">Costa</vs-radio>
            </li>
          </ul>
        </div>
        <div class="vx-col w-full md:w-1/2">
          <span class="font-semibold">Seleccione el período</span>
          <div class="flex flex-col sm:flex-row">
            <v-select
              :options="arrayPeriodos"
              :reduce="periodo => periodo.idperiodoescolar"
              label="periodoescolar"
              class="w-full mt-2"
              v-model="periodoSelected"
              @input="filtrarReporte()"
            />
            <vs-button color="primary" @click="filtrarReporte()" class="sm:ml-2 mb-2 mt-2 w-full sm:w-auto" type="filled">
              Filtrar
            </vs-button>
          </div>
        </div>
      </div>
    </div>
    <vs-divider></vs-divider>
    <div class="mb-4 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-0">
      <vs-radio v-model="filtroQuitado" vs-value="0" vs-name="filtroQuitado" @input="aplicarFiltroServidor()">
        Faltan quitar archivos <b>({{ contadorFaltan > 0 ? contadorFaltan : contadorFaltanCalculado }})</b>
      </vs-radio>
      <vs-radio v-model="filtroQuitado" vs-value="1" vs-name="filtroQuitado" class="sm:ml-4" @input="aplicarFiltroServidor()">
        Ya quitados <b>({{ contadorQuitados > 0 ? contadorQuitados : contadorQuitadosCalculado }})</b>
      </vs-radio>
    </div>
  <div v-if="totalPages && totalPages > 1" class="mb-4 flex flex-col lg:flex-row lg:items-center lg:justify-between bg-gray-100 p-3 rounded gap-3">
      <div class="text-sm lg:text-base">
        <b>Total registros:</b> {{ totalItems }}
        <span class="ml-2 lg:ml-4"><b>Página:</b> {{ page }} de {{ totalPages }}</span>
        <span class="block sm:inline sm:ml-2 lg:ml-4 mt-1 sm:mt-0"><b>Archivos Por página:</b> {{ perPage }}</span>
      </div>
      <div class="flex items-center justify-center lg:justify-end flex-wrap gap-1">
        <span v-if="page > 1" @click="cambiarPagina(1)" class="px-2 py-1 rounded cursor-pointer bg-white border text-xs sm:text-sm hover:bg-gray-50">« Primera</span>
        <span v-if="page > 1" @click="cambiarPagina(page - 1)" class="px-2 py-1 rounded cursor-pointer bg-white border text-xs sm:text-sm hover:bg-gray-50">‹</span>
        <span v-for="n in visiblePages" :key="n" @click="cambiarPagina(n)" :class="['px-2 py-1 rounded cursor-pointer text-xs sm:text-sm', n === page ? 'bg-primary text-white font-bold' : 'bg-white border hover:bg-gray-50']">
          {{ n }}
        </span>
        <span v-if="page < totalPages" @click="cambiarPagina(page + 1)" class="px-2 py-1 rounded cursor-pointer bg-white border text-xs sm:text-sm hover:bg-gray-50">›</span>
        <span v-if="page < totalPages" @click="cambiarPagina(totalPages)" class="px-2 py-1 rounded cursor-pointer bg-white border text-xs sm:text-sm hover:bg-gray-50">Última »</span>
      </div>
    </div>
    <div v-if="selectedRows.length > 0" class="mb-3">
      <vs-button color="danger" type="relief" @click="openConfirmQuitarArchivos();" icon="icon-trash" class="w-full sm:w-auto block">
        <span class="hidden md:inline">Quitar {{ totalArchivosSeleccionados }} archivos de {{ selectedRows.length }} cursos seleccionados</span>
        <span class="md:hidden text-xs sm:text-sm flex flex-col items-center">
          <span>Quitar archivos seleccionados</span>
          <span class="text-xs mt-1">{{ totalArchivosSeleccionados }} archivos · {{ selectedRows.length }} cursos</span>
        </span>
      </vs-button>
    </div>
    <div class="overflow-x-auto">
      <vs-table
        :data="currentPageData"
        :pagination="false"
        stripe
        multiple
        v-model="selectedRows"
      >
        <template slot="header">
          <vs-chip color="primary">Total cursos en página: <b>{{ currentPageData.length }}</b></vs-chip>
        </template>
        <template slot="thead">
          <vs-th>Asignatura</vs-th>
          <vs-th>Curso</vs-th>
          <vs-th>Archivos</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr v-for="curso in data" :key="curso.codigo" :data="curso">
            <vs-td>
              <span class="text-sm">{{ curso.nombreasignatura }}</span>
            </vs-td>
            <vs-td>
              <div class="text-sm">
                <span class="font-bold"># {{ curso.curso_idcurso }}</span><br>
                {{ curso.nombre }} ({{ curso.codigo }})<br>
                <vs-divider></vs-divider>
                <b>Último ingresó al módulo de tareas estudiante:</b>
                <p class="text-xs">{{ curso.fechaUltimaVisitaEstudiante || 'Ninguno' }}</p>
                <b>Último ingresó al módulo de tareas docente:</b>
                <p class="text-xs">{{ curso.fechaUltimaVisitaDocente || 'Sin fecha' }}</p>
              </div>
            </vs-td>
            <vs-td>
              <div v-for="archivo in curso.archivos" :key="archivo.id" class="mb-2">
                <span
                  @click="abrirArchivo(archivo.url)"
                  target="_blank"
                  class="text-primary cursor-pointer hover:underline text-sm break-all"
                >
                  {{ archivo.url }}
                </span>
                <span v-if="archivo.peso" class="ml-2 text-xs text-gray-600"></span>
                <br>
                <div class="text-xs mt-1">
                  <b>Peso:</b>
                  <span>{{ archivo.peso || 'Desconocido' }}</span>
                  <br>
                  <b>Fecha Tarea:</b>
                  <span>{{ archivo.fecha_tarea || 'Desconocido' }}</span>
                </div>
                <vs-divider></vs-divider>
              </div>
              <div v-if="curso.fecha_quitado_archivos">
                <span class="text-xs text-danger">Fecha quitado archivos: {{ curso.fecha_quitado_archivos }}</span>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>

    <!-- Modal de resultados -->
    <vs-popup title="Resultados de Eliminación" :active.sync="showResultsModal">
      <div class="p-2 sm:p-4">
        <div class="overflow-x-auto">
          <TableReutilizableVue
            :title="'Resultados del proceso de eliminación'"
            :headers="['Código del Curso','ID Curso','Archivos Eliminados','No Encontrados']"
            :fieldKeys="['codigo','idcurso','eliminados','no_encontrados']"
            :tableData="resultadosEliminacion"
          />
        </div>
        <div class="text-center mt-4">
          <vs-button color="primary" @click="showResultsModal = false" class="w-full sm:w-auto">Cerrar</vs-button>
        </div>
      </div>
    </vs-popup>

    <br><br><br><br><br><br><br><br><br><br>
  </vx-card>
</template>
<script>
import vSelect from 'vue-select'
import PeriodoRepository from '@/repositories/PeriodoRepository';
const TableReutilizableVue = () => import('@/views/pedidos2/pedidos/reportes/components/TableReutilizable.vue')

export default {
  components: {
    'v-select': vSelect,
    TableReutilizableVue,
  },
  data() {
    return {
      arrayReporte    : [],
      arrayReporteOriginal: [], // Copia original de los datos
      arregloFormato  : [],
      periodoSelected : '',
      arrayPeriodos   : [],
      region          : 1,
      totalItems: 0,
      page: 1,
      perPage: 200,
      totalPagesServer: 1,
      filtroQuitado: "0",
      arrayReporteFiltrada: [],
      selectedRows: [],
      showConfirmRemove: false,
      showResultsModal: false,
      resultadosEliminacion: [],
      contadorFaltan: 0,
      contadorQuitados: 0,
      usuario:[],
      ruta:'tareas',
    }
  },
  methods: {
    limpiarDatosYCambiarRegion() {
      // Limpiar todos los arrays de datos
      this.arrayReporte = [];
      this.arrayReporteOriginal = [];
      this.arrayReporteFiltrada = [];
      this.selectedRows = [];

      // Limpiar períodos y selección
      this.arrayPeriodos = [];
      this.periodoSelected = '';

      // Resetear paginación
      this.totalItems = 0;
      this.totalPagesServer = 1;
      this.page = 1;

      // Resetear contadores
      this.contadorFaltan = 0;
      this.contadorQuitados = 0;

      // Obtener períodos de la nueva región
      this.obtenerPeriodos();
    },
    openConfirmQuitarArchivos() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmación',
        text: `¿Está seguro de quitar ${this.totalArchivosSeleccionados} archivos de ${this.selectedRows.length} cursos seleccionados?`,
        acceptText: 'Sí, quitar',
        cancelText: 'Cancelar',
        accept: this.removerSeleccionados
      });
    },
    removerSeleccionados() {
      this.$vs.loading();
      const cursos = this.selectedRows.map(row => ({
        curso_idcurso: row.curso_idcurso,
        codigo: row.codigo
      }));
      let formData = new FormData();
      formData.append('cursos', JSON.stringify(cursos));
      formData.append('ruta', this.ruta);
      formData.append('usuario_quita_archivos', this.usuario.idusuario);
      this.$http.post(this.$data_url + 'api/removerArchivosTareas', formData)
        .then(res => {
          this.$vs.loading.close();
          if (res.data.status === 1) {
            this.$vs.notify({ text: 'Archivos removidos correctamente.', color: 'primary' });

            // Guardar los resultados y mostrar modal si hay resultados
            if (res.data.resultados && res.data.resultados.length > 0) {
              this.resultadosEliminacion = res.data.resultados;
              this.showResultsModal = true;
            }

            // Recargar los datos desde la API para reflejar los cambios
            this.filtrarReporte();
            this.selectedRows = [];
          } else {
            this.$vs.notify({ text: res.data.message || 'Error al remover archivos.', color: 'danger' });
          }
        })
        .catch(err => {
          this.$vs.loading.close();
          this.$vs.notify({ text: 'Error al remover archivos.', color: 'danger' });
          console.error(err);
        });
    },
    filtrarPorQuitado() {
      console.log('Aplicando filtro local. Filtro:', this.filtroQuitado);
      console.log('Array original length:', this.arrayReporteOriginal.length);

      this.selectedRows = []

      // Aplicar filtro local basándose en fecha_quitado_archivos
      if (this.filtroQuitado == 0) {
        // Mostrar solo los que faltan quitar (fecha_quitado_archivos es null)
        this.arrayReporteFiltrada = this.arrayReporteOriginal.filter(a => a.fecha_quitado_archivos === null);
      } else {
        // Mostrar solo los ya quitados (fecha_quitado_archivos no es null)
        this.arrayReporteFiltrada = this.arrayReporteOriginal.filter(a => a.fecha_quitado_archivos !== null);
      }

      console.log('Array filtrado length:', this.arrayReporteFiltrada.length);
      console.log('Filtro aplicado:', this.filtroQuitado == 0 ? 'Faltan quitar' : 'Ya quitados');
    },
    aplicarFiltroServidor() {
      // No reiniciar página porque ahora filtramos localmente
      // this.page = 1;
      // this.getCursosArchivos();

      // Solo aplicar filtro local
      this.filtrarPorQuitado();
    },
    abrirArchivo(nombreArchivo) {
      if (nombreArchivo) {
        const urlArchivo = this.$data_url + this.ruta + '/' + nombreArchivo;
        window.open(urlArchivo, '_blank');
      }
    },
    actualizarPesosEnArchivos(archivosConPesos) {
      console.log('Actualizando pesos con:', archivosConPesos);

      // Crear un mapa para búsqueda rápida por URL con todos los datos
      const mapaArchivos = {};
      archivosConPesos.forEach(archivo => {
        mapaArchivos[archivo.url] = archivo;
      });

      console.log('Mapa de archivos creado:', mapaArchivos);

      // Actualizar los archivos en arrayReporteOriginal
      this.arrayReporteOriginal.forEach(curso => {
        if (curso.archivos && curso.archivos.length > 0) {
          curso.archivos.forEach(archivo => {
            if (mapaArchivos[archivo.url]) {
              const archivoActualizado = mapaArchivos[archivo.url];
              console.log(`Actualizando archivo ${archivo.url}:`, archivoActualizado);

              // Actualizar solo el peso, preservando otros campos
              this.$set(archivo, 'peso', archivoActualizado.peso);

              // Si vienen del servidor, actualizar también estos campos
              if (archivoActualizado.usuarioUltimoTarea !== undefined) {
                this.$set(archivo, 'usuarioUltimoTarea', archivoActualizado.usuarioUltimoTarea);
              }
              if (archivoActualizado.fecha_ingresa_modulo_tareas !== undefined) {
                this.$set(archivo, 'fecha_ingresa_modulo_tareas', archivoActualizado.fecha_ingresa_modulo_tareas);
              }
            }
          });
        }
      });

      // También actualizar arrayReporte para consistencia
      this.arrayReporte.forEach(curso => {
        if (curso.archivos && curso.archivos.length > 0) {
          curso.archivos.forEach(archivo => {
            if (mapaArchivos[archivo.url]) {
              const archivoActualizado = mapaArchivos[archivo.url];
              this.$set(archivo, 'peso', archivoActualizado.peso);

              if (archivoActualizado.usuarioUltimoTarea !== undefined) {
                this.$set(archivo, 'usuarioUltimoTarea', archivoActualizado.usuarioUltimoTarea);
              }
              if (archivoActualizado.fecha_ingresa_modulo_tareas !== undefined) {
                this.$set(archivo, 'fecha_ingresa_modulo_tareas', archivoActualizado.fecha_ingresa_modulo_tareas);
              }
            }
          });
        }
      });

      // Actualizar arrayReporteFiltrada que es lo que se muestra en la tabla
      this.arrayReporteFiltrada.forEach(curso => {
        if (curso.archivos && curso.archivos.length > 0) {
          curso.archivos.forEach(archivo => {
            if (mapaArchivos[archivo.url]) {
              const archivoActualizado = mapaArchivos[archivo.url];
              this.$set(archivo, 'peso', archivoActualizado.peso);

              if (archivoActualizado.usuarioUltimoTarea !== undefined) {
                this.$set(archivo, 'usuarioUltimoTarea', archivoActualizado.usuarioUltimoTarea);
              }
              if (archivoActualizado.fecha_ingresa_modulo_tareas !== undefined) {
                this.$set(archivo, 'fecha_ingresa_modulo_tareas', archivoActualizado.fecha_ingresa_modulo_tareas);
              }
            }
          });
        }
      });

      console.log('Actualización de pesos completada');
    },
    obtenerPeriodos() {
      this.$vs.loading();
      PeriodoRepository.getPeriodos()
        .then(p => {
          this.arrayPeriodos = p.data;
          this.filtrarPeriodos(p.data);
          this.$vs.loading.close();
        })
        .catch(error => {
          this.$vs.notify({ text: 'Error al cargar los períodos', color: 'danger' });
          this.$vs.loading.close();
        });
    },
    filtrarPeriodos(datos) {
      this.arrayPeriodos = datos.filter(p => p.region_idregion == this.region);
    },
    filtrarReporte() {
      if (!this.periodoSelected) {
        this.$vs.notify({
          text: 'Seleccione un período válido antes de continuar.',
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-triangle',
        });
        return;
      }
      this.getCursosArchivos();
    },
    getCursosArchivos() {
      let me = this;
      me.$vs.loading();
      if (!me.periodoSelected) {
        me.$vs.loading.close();
        this.$vs.notify({
          text: 'Seleccione un período válido antes de continuar.',
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-triangle',
        });
        return;
      }

      // Cambiar a paginación del servidor - solicitar página actual
      // Por ahora no enviamos filtro_quitado al servidor, filtramos localmente
      let url = `${this.$server_url}estudianteMetodosGet?getCursosXPeriodoArchivos=1&idperiodo=${me.periodoSelected}&page=${me.page}&per_page=${me.perPage}`;
      this.$http.get(url)
        .then(function (res) {
          console.log('Respuesta API:', res.data); // Debug

          // Debug: revisar estructura de archivos
          if (res.data.data && res.data.data.length > 0) {
            console.log('Primer curso con archivos:', res.data.data.find(curso => curso.archivos && curso.archivos.length > 0));
            res.data.data.forEach(curso => {
              if (curso.archivos && curso.archivos.length > 0) {
                console.log(`Curso ${curso.codigo} - Archivos:`, curso.archivos);
              }
            });
          }

          me.arrayReporte = res.data.data || []; // datos de la página actual
          me.arrayReporteOriginal = [...(res.data.data || [])]; // Crear copia original de la página actual

          // Usar los totales del servidor para la paginación
          me.totalItems = parseInt(res.data.total) || 0;
          me.page = parseInt(res.data.page) || 1;
          me.perPage = parseInt(res.data.per_page) || 200;
          me.totalPagesServer = parseInt(res.data.total_pages) || 1;

          // Actualizar contadores si vienen del servidor
          me.contadorFaltan = parseInt(res.data.contador_faltan) || 0;
          me.contadorQuitados = parseInt(res.data.contador_quitados) || 0;

          // Si no hay datos pero hay total, mostrar información
          if ((!res.data.data || res.data.data.length === 0) && res.data.total > 0) {
            me.$vs.notify({
              text: `El servidor indica ${res.data.total} registros, pero no se devolvieron datos para esta página.`,
              color: 'warning',
              time: 5000
            });
          }
          me.f_getPesoArchivo(); // colocar el peso a los archivos
          me.filtrarPorQuitado(); // Aplicar filtro después de cargar datos

          // Forzar actualización de la vista
          me.$nextTick(() => {
            me.$forceUpdate();
          });

          me.$vs.loading.close();
        })
        .catch(function (error) {
          me.arrayReporte = [];
          me.arrayReporteOriginal = [];
          me.arrayReporteFiltrada = [];
          me.totalItems = 0;
          me.totalPagesServer = 1;
          me.contadorFaltan = 0;
          me.contadorQuitados = 0;
          me.$vs.loading.close();
          me.$vs.notify({
            text: 'Error al cargar los datos. Verifique el período seleccionado.',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-x',
          });
          console.log(error);
        });
    },
    f_getPesoArchivo(){
      let me = this
      console.log("arrayReporteOriginal:", me.arrayReporteOriginal)
      // extraer los archivos con flatmap
      let archivos = me.arrayReporteOriginal.flatMap(item => item.archivos || []);
      console.log("Archivos extraídos:", archivos);

      // Si no hay archivos, no hacer la llamada
      if (archivos.length === 0) {
        console.log("No hay archivos para procesar");
        return;
      }

      // Preparar FormData para enviar a la API
      let formData = new FormData();
      formData.append('ruta', me.ruta);
      formData.append('archivosTareas', JSON.stringify(archivos));

      console.log("Enviando a API:", {
        ruta: me.ruta,
        cantidad_archivos: archivos.length
      });

      // Llamar a la API para obtener los pesos
      me.$http.post(me.$data_url + 'api/getFileSize', formData)
        .then(function(res) {
          console.log('Pesos de archivos recibidos:', res.data);

          // Debug específico para los campos que no se muestran
          if (res.data && res.data.length > 0) {
            res.data.forEach(archivo => {
              console.log(`Archivo ${archivo.url}:`, {
                peso: archivo.peso,
                usuarioUltimoTarea: archivo.usuarioUltimoTarea,
                fecha_ingresa_modulo_tareas: archivo.fecha_ingresa_modulo_tareas
              });
            });
          }

          // Actualizar los archivos con sus pesos usando el método correcto
          me.actualizarPesosEnArchivos(res.data);

          // Forzar actualización de la vista
          me.$forceUpdate();
        })
        .catch(function(err) {
          console.error('Error al obtener pesos de archivos:', err);
          // No mostrar error al usuario, solo log
        });
    },
    cambiarPagina(nuevaPagina) {
      if (nuevaPagina !== this.page && nuevaPagina >= 1 && nuevaPagina <= this.totalPages) {
        this.page = nuevaPagina;
        this.getCursosArchivos(); // Ahora sí llamamos al servidor para la nueva página
      }
    },
  },
  computed: {
    // Calcular contadores basándose en los datos de la página actual
    contadorFaltanCalculado() {
      return this.arrayReporteOriginal.filter(a => a.fecha_quitado_archivos === null).length;
    },
    contadorQuitadosCalculado() {
      return this.arrayReporteOriginal.filter(a => a.fecha_quitado_archivos !== null).length;
    },
    totalPages() {
      return this.totalPagesServer || 1; // Usar las páginas del servidor
    },
    visiblePages() {
      let pages = [];
      let start = Math.max(1, this.page - 2);
      let end = Math.min(this.totalPages, this.page + 2);
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      if (start > 1) pages.unshift(1);
      if (end < this.totalPages) pages.push(this.totalPages);
      return pages;
    },
    currentPageData() {
      // Para paginación del servidor, mostrar todos los datos de la página actual
      return this.arrayReporteFiltrada;
    },
    totalArchivosSeleccionados() {
      return this.selectedRows.reduce((acc, curso) => acc + (curso.archivos ? curso.archivos.length : 0), 0);
    }
  },
  watch: {
    // Aplicar filtro automáticamente cuando cambien los datos
    arrayReporteOriginal: {
      handler() {
        this.filtrarPorQuitado();
      },
      immediate: true
    },
    // Aplicar filtro cuando cambie el radio button
    filtroQuitado() {
      this.filtrarPorQuitado();
    }
  },
  // ...existing code...
  mounted() {
    this.usuario = JSON.parse(localStorage.getItem("usuario"));
    this.obtenerPeriodos();
  }
}
</script>

